import { useState } from "react";
import { useRouter } from "next/router";
import { listKategori, listSubject } from "../../utils/aboutUtils";
import { toast } from "react-hot-toast";
import { gql } from "@urql/core";
import { useMutation } from "urql";
import fetch from "../fetch";

const mutate = gql`
  mutation MyMutation($object: cms_questions_insert_input!) {
    insert_cms_questions_one(object: $object) {
      id
    }
  }
`;

const initialForm = {
  name: "",
  email: "",
  category: "",
  subject: "",
  content: "",
};

export default function useContact() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(initialForm);

  const [{ fetching }, handlePost] = useMutation(mutate);

  const isNotValid = (name, email, category, subject, content) => {
    if (name.length === 0) {
      return true;
    }
    if (email.length === 0) {
      return true;
    }
    if (category.length === 0) {
      return true;
    }
    if (subject.length === 0) {
      return true;
    }
    if (content.length === 0) {
      return true;
    }

    return false;
  };

  const submit = async (e, data) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      if (
        isNotValid(
          data.name,
          data.email,
          data.category,
          data.subject,
          data.content
        )
      ) {
        throw new Error("Tidak boleh ada yang kosong");
      }

      const { error } = await handlePost({
        object: {
          created_at: new Date(),
          name: data.name,
          content: data.content,
          email: data.email,
          status: 0,
          cms_question_subject_id: listSubject.findIndex(
            (e) => e === data.subject
          ),
          cms_question_category_id: listKategori.findIndex(
            (e) => e === data.category
          ),
        },
      });
      if (error) {
        throw new Error(error);
      }

      const finalBody = {
        recipients: ["sekretariat@wardayacollege.com"],
        subject: `Pertanyaan dari ${data.name} : ${data.category} - ${data.subject}`,
        body: data.content,
      };
      const { error: errorSendToAdmin, status } = await fetch(
        process.env.NEXT_PUBLIC_API + `/api/v1/admin/email`,
        {
          method: "POST",
          body: JSON.stringify(finalBody),
          headers: {
            "API-KEY": process.env.NEXT_PUBLIC_SSO_API_KEY,
          },
        }
      );

      if (status !== "success") {
        throw new Error(errorSendToAdmin);
      }

      toast.success("Pesan terkirim");
      router.reload();
    } catch (err) {
      console.log(err.message);
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    setData,
    isLoading,
    setIsLoading,
    submit,
    fetching,
  };
}
